export var radians = Math.PI / 180;
export var degrees = 180 / Math.PI;
